// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EJeb7","col":"styles_col__1MZkG"};